// ─────────────────────────────────────────────
// LLM Evaluation — Shared Types
// ─────────────────────────────────────────────
/**
 * Curated list of prompt types that have eval support.
 * Values must match the `name` field of the corresponding PromptTemplate in @super/prompt-sdk.
 */
export var EvalPromptType;
(function (EvalPromptType) {
    EvalPromptType["PROPERTY_MATCHING"] = "property-matching";
    EvalPromptType["GROUP_DETECTION"] = "group-detection";
    EvalPromptType["SCENARIO_CLASSIFICATION"] = "scenario-classification";
    EvalPromptType["HANDOFF_WORKFLOW_SELECTION"] = "handoff-workflow-selection";
    EvalPromptType["SMS_HANDOFF_WORKFLOW_SELECTION"] = "sms-handoff-workflow-selection";
    EvalPromptType["ACTION_GROUP_SELECTION"] = "action-group-selection";
})(EvalPromptType || (EvalPromptType = {}));
export const EVAL_PROMPT_TYPE_LABELS = {
    [EvalPromptType.PROPERTY_MATCHING]: 'Property Matching',
    [EvalPromptType.GROUP_DETECTION]: 'Group Detection',
    [EvalPromptType.SCENARIO_CLASSIFICATION]: 'Scenario Classification',
    [EvalPromptType.HANDOFF_WORKFLOW_SELECTION]: 'Workflow Selection (Voice)',
    [EvalPromptType.SMS_HANDOFF_WORKFLOW_SELECTION]: 'Workflow Selection (SMS)',
    [EvalPromptType.ACTION_GROUP_SELECTION]: 'Action Group Selection',
};
export var EvalCaseSource;
(function (EvalCaseSource) {
    EvalCaseSource["MANUAL"] = "MANUAL";
    EvalCaseSource["SESSION"] = "SESSION";
})(EvalCaseSource || (EvalCaseSource = {}));
export var EvalRunScope;
(function (EvalRunScope) {
    EvalRunScope["GLOBAL"] = "GLOBAL";
    EvalRunScope["COMPANY"] = "COMPANY";
})(EvalRunScope || (EvalRunScope = {}));
export var EvalRunStatus;
(function (EvalRunStatus) {
    EvalRunStatus["PENDING"] = "PENDING";
    EvalRunStatus["RUNNING"] = "RUNNING";
    EvalRunStatus["COMPLETED"] = "COMPLETED";
    EvalRunStatus["FAILED"] = "FAILED";
})(EvalRunStatus || (EvalRunStatus = {}));
//# sourceMappingURL=eval.js.map